import { useNavigate } from "react-router";
import { includes } from "lodash";

import { routeBlacklist } from "./useOrgRedirect";

export const buildOrgRoute = (path: string): string | null => {
  // if the path is in the blacklist (not a route that should be redirected), return the path
  if (includes(routeBlacklist, path.split("/")[1])) {
    return path;
  }

  const currentOrg = localStorage.getItem("recentOrg");

  if (!currentOrg) {
    console.error("No recentOrg found in localStorage");
    return null;
  }

  // Check if the path already starts with /org/<id>
  const orgPrefixPattern = new RegExp(`^/org/${currentOrg}`);

  if (!orgPrefixPattern.test(path) && !includes(path, "account")) {
    return `/org/${currentOrg}${path.startsWith("/") ? "" : "/"}${path}`;
  }

  return path;
};

const useOrgNavigate = () => {
  const navigate = useNavigate();

  const orgNavigate = (
    path: string,
    options?: { replace?: boolean; state?: any }
  ) => {
    const orgPath = buildOrgRoute(path);
    if (orgPath) {
      navigate(orgPath, options);
    }
  };

  return orgNavigate;
};

export default useOrgNavigate;
